import PresupuestosGraficoCasosFinalizados from './PresupuestosGraficoCasosFinalizados';

export default PresupuestosGraficoCasosFinalizados;
